module.exports = __webpack_public_path__ + "img/029-tourist.0019042d.png";